<template>
  <div>
    <van-cell-group class="user_info">
      <van-cell>
        <!-- <van-col span="18">游戏玩家</van-col> -->
        <!-- <van-col span="6"><van-button plain type="primary">登录</van-button></van-col> -->
        <template #title>
          <!-- <van-icon name="user-o" size="20"/> -->
          <span class="custom-title" v-show="!showLoginButton">{{ server_name }}-{{ role_name }}</span>
        </template>
        <template #right-icon>
          <van-button plain type="primary" size="small" @click="showLoginPopup" v-show="showLoginButton">登录</van-button>
          <van-button plain type="primary" size="small" @click="handleLogout" v-show="!showLoginButton">退出</van-button>
        </template>
      </van-cell>
    </van-cell-group>

    <van-popup
        class="login-popup"
        closeable
        close-icon="close"
        round
        v-model="showLogin"
    >
      <van-row class="login-title">
        <van-col span="24">玩家登录</van-col>
      </van-row>
      <van-form @submit="onSubmitLogin">
        <van-field
            v-model="server_name"
            name="区服"
            label="区服"
            placeholder="区服名称"
            clearable
            :rules="[{ required: true, message: '请填写区服名称' }]"
        />
        <van-field
            v-model="role_name"
            name="用户名"
            label="用户名"
            placeholder="用户名"
            clearable
            :rules="[{ required: true, message: '请填写用户名' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <van-cell-group class="game-giftpack-group" v-for="(item, index) in data.list" :key="index">
      <van-cell>
        <van-image class="game-icon" width="56" height="56"  v-show="item.external_name == '烽火龙城'" :src="require('@/assets/fenghuolcgiftpack.png')" />
        <div class="title game-title">
          <strong>{{ item.external_name }}</strong>
        </div>

      </van-cell>
      <van-cell :label="gift.game_prop_names" v-for="(gift, gift_index) in item.game_giftpacks" :key="gift_index">
        <template #title>
          <span class="title">{{ gift.show_giftpack_name }}</span>
          <van-tag type="success" plain v-for="(os, key) in gift.os" :key="key">{{ osList[os] }}</van-tag>
        </template>
        <template #right-icon>
          <van-button type="info" size="small" @click="handlePick(gift.id, gift_index, index)" v-show="!gift.cdkey">领取</van-button>
          <van-button type="info" size="small" @click="handleShowCdkey(gift.cdkey)" v-show="gift.cdkey">查看</van-button>
        </template>
      </van-cell>
      <van-cell v-if="item.count > 3" @click="handleGetMore(item.id, index, $event)">
        <p class="more">查看更多礼包({{ item.count - 3 }})<van-icon name="arrow-down" /></p>
      </van-cell>
    </van-cell-group>

    <!-- <van-cell-group class="game-giftpack-group">
      <van-cell>
        <div>
            <van-image width="56" height="56" src="https://img.yzcdn.cn/vant/cat.jpeg" />王者传奇
        </div>
      </van-cell>
      <van-cell label="元宝*100;金币*200">
          <template #title>
            <span class="custom-title">新手礼包</span>
            <van-tag type="success" plain>标签</van-tag>
        </template>
          <template #right-icon>
            <van-button type="info">领取</van-button>
        </template>
      </van-cell>
    </van-cell-group> -->
    <van-dialog v-model="dialogCdkeyShow" title="兑换码" confirm-button-text="复制" :message="dialog_cdkey" :before-close="beforeClose">
      <!-- <span class="dialog_content"><strong>{{ dialog_cdkey }}</strong></span> -->
    </van-dialog>

  </div>
</template>

<script>

import { miniGiftpacksByGid, gameGiftpackList, loginMiniGame, minPick, getFhlcOfOpenid } from "@/api/gameGiftpack"
import { Toast } from 'vant';
import { getUsername, getServername, setServername,
  getRolename, setRolename, removeRolename, removeServername, setUserid, getUserid, removeUserid } from '@/utils/auth';
// import Clipboard from 'clipboard'
export default {
  data() {
    return {
      username: '游戏玩家',
      showLoginButton: true,
      showLogin: false,
      data: {
        list: []
      },
      server_name: undefined,
      role_name: undefined,
      account: undefined,
      password: undefined,
      game_id:'2f00fcc7e6ec46bba4ac2bf32f29d27f',
      account_pattern: /^\w{4,20}$/,
      dialogCdkeyShow: false,
      dialog_cdkey: undefined,
      osList: {ios: '苹果', android: '安卓'},
      code: '',
      openid: localStorage.getItem('fhopenid')
    };
  },
  created() {
    this.getOpenid(),
    this.getSimple(),
    this.loginState()
  },
  methods: {

    loginState() {
      if (getRolename()) {
        this.server_name = getServername()
        this.role_name = getRolename()
        this.showLoginButton = false
        this.openid = localStorage.getItem('fhopenid')
      }
    },
    getOpenid(){

      let url = location.search
      if(url.indexOf('code')!=-1 ){
        let theRequest = {};
        if (url.indexOf("?") !== -1) {
          let str = url.substr(1)
          let strs = str.split("&")
          for(let i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
        }
        this.code = theRequest.code
        if(!localStorage.getItem('fhopenid')){
          getFhlcOfOpenid({code: this.code})
              .then(response => {
                this.openid = localStorage.getItem('fhopenid')
                localStorage.setItem('fhopenid', response.openid)
              })
              .catch(()=>{

              })
        }

      }else{

        if(localStorage.getItem('fhopenid') ==''){
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe22e7670aa0a06f3&redirect_uri=https%3A%2F%2Fwx.playhy.com%2F%23%2Fgift%2Ffhlc&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
        }

      }

    },
    // 查看更多
    handleGetMore(game_id, index) {
      let params = {'game_id': game_id}
      if (getUserid()) {
        params['account'] = getUsername()
      }
      gameGiftpackList(params).then(response => {
        this.data.list[index]['game_giftpacks'] = response
        this.data.list[index]['count'] = false
        console.log(response)
      }).catch(() => {
      })
    },
    getSimple() {
      let params = {}
      if (getUserid()) {
        params = {userid: getUserid(), account: getUsername(), game_ids: ['2f00fcc7e6ec46bba4ac2bf32f29d27f']}
      }else {
        params = {game_ids: ['2f00fcc7e6ec46bba4ac2bf32f29d27f']}
      }

      miniGiftpacksByGid(params).then(response => {
        this.data.list = response
      }).catch(() => {

      })
    },
    showLoginPopup() {
      this.showLogin = true
    },
    // 登录
    onSubmitLogin() {
      // const that = this
      Toast.loading({
        message: '登录中，请稍等!',
        forbidClick: true
      })
      loginMiniGame({role_name: this.role_name, server: this.server_name,game_id: this.game_id}).then(response => {
        console.log(response)

        // this.showLogin = false
        // this.showLoginButton = false
        // this.username = response.account

        setServername(response.server)
        setRolename(response.role_name)
        setUserid(response.user_id)


        // this.$router.go(0)
        location.reload()
      }).catch(() => {

      })
    },
    // 领取
    handlePick(id, gift_index, index) {
      if (!getUserid()) {
        this.showLogin = true
      } else {

        minPick({id: id, userid: getUserid(),openid: localStorage.getItem('fhopenid')}).then(response => {
          this.dialog_cdkey = response.cdkey
          this.dialogCdkeyShow = true
          // 按钮切换为查看
          this.data.list[index]['game_giftpacks'][gift_index]['cdkey'] = response.cdkey
        }).catch(() => {})
      }
    },
    // 查看
    handleShowCdkey(cdkey) {
      this.dialogCdkeyShow = true
      this.dialog_cdkey = cdkey
    },
    beforeClose(action, done) {
      console.log(action)
      if (action === 'confirm') {
        var oInput = document.createElement('input'); //创建一个隐藏input（重要!）
        oInput.value = this.dialog_cdkey;    //赋值
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = 'oInput';
        oInput.style.display = 'none';
        console.log('复制成功')
      }
      done()
    },
    handleLogout() {
      removeRolename()
      removeServername()
      removeUserid()
      location.reload()
    }
  },

};
</script>

<style >

html,
body {
  height: 100%;
}
body {
  background: #f5f5fa;
  font-size: 14px;
}
.user_info {
  height: 62px;
  /* padding: 10px 0; */
  background: #fff;
}
/* .user-info > div:nth-child(1) div i:before {
  font-size: 0.24rem;
} */
.game-giftpack-group {
  margin: 15px 0;
}
.title {
  font-size: 16px;
  color: #333;
}
.game-title {
  float: left;
  margin-left: 10px;
  line-height: 56px;
}
.game-icon {
  float: left;
}
.more {
  color: #999;
  font-size: 14px;
  text-align: center;
  margin: 4px 0;
  /* line-height: 1; */
  /* padding: 15px 0; */
  /* border-top: .01rem solid #f1f1f6; */
}
.van-tag {
  margin-left: 5px;
}
.login-popup {
  width: 88%;
}
.login-title {
  height: 65px;
  text-align: center;
  line-height: 65px;
  font-size: 20px;
}
.van-dialog__content {
  text-align: center;
  margin: 18px;
}
</style>
